/**
 * Password requirements component
 * Displays real-time validation feedback as user types
 */

import { Check, X } from 'lucide-react';
import { validatePassword } from '@/lib/passwordValidator';
import { cn } from '@/lib/utils';

interface PasswordRequirementsProps {
  password: string;
}

export function PasswordRequirements({ password }: PasswordRequirementsProps) {
  const { requirements } = validatePassword(password);

  return (
    <div className="space-y-1">
      {requirements.map((requirement) => (
        <div
          key={requirement.name}
          className={cn(
            'flex items-center gap-2 text-xs',
            requirement.met ? 'text-green-600' : 'text-gray-400'
          )}
        >
          {requirement.met ? <Check className="h-4 w-4" /> : <X className="h-4 w-4" />}
          <span>{requirement.message}</span>
        </div>
      ))}
    </div>
  );
}
